import swal from 'sweetalert'
import { Modal, Typography } from "antd"; 

const { Text } = Typography;

export default function ScreenCapturePreview({ preview, onClose, onSave }) {
  const handleCancel = () => {
    swal({
      title: "Are you sure?",
      text: "You want to discard this screen capture?",
      icon: "warning",
      buttons: ["No", "Yes, Close"],
      dangerMode: true,
    }).then((willClose) => {
      if (willClose) {
        onClose(); 
      }
    });
  };

  const handleSave = () => {
      onSave(preview.blob);
  };

  return (
    <Modal
      open={!!preview}
      onCancel={handleCancel}
      maskClosable={false}
      onOk={handleSave}
      okText="Confirm"
      width={770}
    >
      <Text strong>{preview?.type === "video" ? "Preview Recording" : "Edit Screenshot"}</Text>
      <div style={{ marginTop: 15, position: "relative", width: "100%", height: 500 }}>
        {preview?.type === "video" ? (
          <video src={preview?.url} controls style={{ width: "100%", height: "100%" }} />
        ) : ( 
            <img
            src={preview?.url}
            alt="screenshot"
            style={{  width: "100%", height: "100%", objectFit: "contain", border: "1px solid #eee",
            }}
          />
        )}
      </div>
    </Modal>
  );
}